var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagAruba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_14900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32C20.8494 32 25.1946 29.8423 28.1288 26.4348H3.87119C6.80537 29.8423 11.1506 32 16 32Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 7.1635 24.8365 0 16 0C7.1635 0 0 7.1635 0 16C0 17.4442 0.1925 18.8431 0.551188 20.1739H31.4489C31.8075 18.8431 32 17.4442 32 16Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.27148 22.261C1.57992 22.9857 1.94048 23.6827 2.34805 24.3479H29.6513C30.0589 23.6827 30.4194 22.9857 30.728 22.261H1.27148Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33205 10.0915L4.20605 8.71186L7.33205 7.33224L8.71162 4.2063L10.0912 7.33224L13.2171 8.71186L10.0912 10.0915L8.71162 13.2174L7.33205 10.0915Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71231 5.9292L9.56425 7.85976L11.4949 8.71182L9.56425 9.56382L8.71231 11.4944L7.86025 9.56382L5.92969 8.71182L7.86025 7.85976L8.71231 5.9292Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_14900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagAruba);
export default __webpack_public_path__ + "static/media/flag_aruba.754dbd4dbce23cd8995889c7ec12507d.svg";
export { ForwardRef as ReactComponent };